export const SET_SUBMITTEDFORMDATA = "SET_SUBMITTEDFORMDATA";

export const setSubmittedFormData = payload => {
    return {
        type: SET_SUBMITTEDFORMDATA,
        payload
    };
};